import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-grupo-formulario',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit{
  dato: FormGroup;
  tieneid;
  form_carreras_planes;
  carreras_disonibles = [];

  // Mensaje
  titulo; mensaje; clase;

  tamano = document.body.clientHeight;
  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder) { }

  ngOnInit() {
    this.dato = this.fb.group({
      id: [''],
      nombre: ['', [Validators.required]],
      activo: ['0', [Validators.required]],
      carreras_planes: this.fb.array([])
    });

    this.form_carreras_planes = {
      carreras_id: ['', [Validators.required]]
    };

    this.route.params.subscribe(params => {
      this.tieneid = params['id'];
    });
    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }

  descartar(event, data, i){
    let id_seleccionado = this.dato.controls.carreras_planes.value[i].carreras_id;
    this.dato.controls.carreras_planes.value.forEach((element, key) => {
      // console.log("muestra: ", element, "seleccionado: ", id_seleccionado)
      //console.log(key, i)
      if (key!=i && element.carreras_id==id_seleccionado) {
        //console.log("muestra: ", element.id, "seleccionado: ", id_seleccionado)
        //this.dato.controls.carreras_planes.value[i].carreras_id = '';
        //console.log(this.dato.controls.carreras_planes[i].controls.carreras_id)
        this.titulo = 'Verifique';
        this.mensaje = 'La carrera que seleccionó ya la se cargó antes';
        this.clase = 'info';
        document.getElementById("message").click();
      }

      //console.log(this.dato.value)
    });
  }

}
